module.exports = __webpack_public_path__ + "img/mobile-25.6a6b8970.png";